<template>
  <header class="header-container">
    <div class="header-left" @click="$emit('navTo', 'Sound Pressure Levels')">
      <h1 class="logo">Virtual Acoustician</h1>
    </div>

    <div class="header-right">
      <!-- Hamburger menu for small screens -->
      <button class="hamburger" @click="toggleMenu" aria-label="Menu">
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
      </button>

      <!-- Dropdown nav for mobile -->
      <nav class="mobile-nav" :class="{ open: menuOpen }">
        <ul>
          <li v-if="isAdmin" @click="navigate('Modelling')">Modelling</li>
          <li @click="navigate('UserDocs')">Docs</li>
          <li @click="navigate('Review Requests')">Requests</li>
          <li @click="$emit('open-my-reports')">My Reports</li>
          <!-- Keep user dropdown interactive by allowing overflow and high z-index -->
          <li class="user-dropdown">
            <UserDetails :profile="profile" />
          </li>
        </ul>
      </nav>

      <!-- Inline nav for desktop -->
      <nav class="desktop-nav">
        <ul>
          <li v-if="isAdmin" @click="navigate('Modelling')">Modelling</li>
          <li @click="navigate('UserDocs')">Docs</li>
          <li @click="navigate('Review Requests')">Requests</li>
          <li @click="$emit('open-my-reports')">My Reports</li>
          <li>
            <UserDetails :profile="profile" />
          </li>
        </ul>
      </nav>
    </div>
  </header>
  <div class="horizontal-line"></div>
</template>

<script>
import UserDetails from "./UserDetails.vue";

export default {
  name: "HeaderWrapper",
  components: { UserDetails },
  props: {
    profile: { type: Object, required: true },
  },
  data() {
    return {
      menuOpen: false,
      isAdmin: false,
    };
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    navigate(target) {
      this.$emit("navTo", target);
      this.menuOpen = false;
    },
    async getUserInfo(profile) {
      const userInfo = await profile?.keycloak?.loadUserInfo();
      console.log("userInfo", userInfo);
      return userInfo;
    },
  },
  watch: {
    profile() {
      this.isAdmin = this.profile?.keycloak?.hasRealmRole("internal_realm_admin_role") ?? false;
    },
  },
};
</script>

<style scoped>
/* Base resets */
.header-container,
.desktop-nav ul,
.mobile-nav ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--colour-surface);
  padding: 0 1rem;
  height: calc(var(--header-height) - 0.25rem);
  /* 0.25rem for horizontal line */
  font-family: "Segoe UI", sans-serif;
}

.logo {
  margin: 0;
  color: var(--color-primary);
  font-size: 1.5rem;
  font-weight: 800;
  cursor: pointer;
}

/* Hamburger styles */
.hamburger {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: var(--icon-size-md);
  height: var(--icon-size-sm);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}

.hamburger-line {
  height: 2px;
  background-color: var(--colour-text-dark);
  border-radius: 1px;
}

/* Desktop nav */
.desktop-nav ul {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.desktop-nav li {
  cursor: pointer;
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--colour-text-dark);
  transition: color 0.2s ease;
}

.desktop-nav li:hover {
  color: var(--color-primary);
}

/* Mobile nav dropdown */
.mobile-nav {
  display: none;
  position: absolute;
  top: 3.75rem;
  right: 1rem;
  background: var(--colour-surface);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: var(--radius-sm);
  /* Allow dropdowns inside to overflow */
  overflow: visible;
  width: 12.5rem;
  z-index: 1000;
  transform-origin: top right;
  transition: transform 0.2s ease, opacity 0.2s ease;
  opacity: 0;
  transform: scaleY(0);
}

.mobile-nav.open {
  display: block;
  opacity: 1;
  transform: scaleY(1);
}

.mobile-nav ul {
  display: flex;
  flex-direction: column;
}

.mobile-nav li {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--colour-bg-light);
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  color: var(--colour-text-dark);
  position: relative;
}

.mobile-nav li:last-child {
  border-bottom: none;
}

.mobile-nav li:hover {
  background-color: var(--colour-bg-subtle);
}

.user-dropdown {
  /* Ensure dropdown renders above */
  overflow: visible;
  z-index: 1100;
}

/* Horizontal accent line */
.horizontal-line {
  width: 100%;
  height: 0.25rem;
  background-color: var(--colour-brand-yellow);
}

/* Responsive breakpoints */
@media (max-width: 800px) {
  .desktop-nav {
    display: none;
  }

  .hamburger {
    display: flex;
  }
}
</style>
